import { type Tempo, tempo } from '@iguanads/tempo'

export type StorageConfigs = {
  start: string
  end: string
  slideIndex: number
  merchantSelected: string
  merchantsSelected: Array<string>
  theme?: string
  messagingToken?: string
  deviceId?: string
}

const saveDate = (dateRange: [Tempo, Tempo]) => {
  const [start, end] = dateRange
  const storage = getConfigs()
  localStorage.setItem(
    'BENTO_CONFIGS',
    JSON.stringify({ ...storage, start, end })
  )
}

const getDate = (): [Tempo, Tempo] => {
  const storage = getConfigs()

  if (storage?.start && storage?.end) {
    return [tempo(storage.start), tempo(storage.end)]
  }

  return [tempo().subtract(7, 'days'), tempo()]
}

const saveSlidePosition = (slideIndex: number) => {
  const storage = getConfigs()
  localStorage.setItem(
    'BENTO_CONFIGS',
    JSON.stringify({ ...storage, slideIndex })
  )
}

const getSlidePosition = (): number => {
  const storage = getConfigs()

  if (storage?.slideIndex) {
    return Number(storage.slideIndex)
  }

  return 0
}

const saveMerchantsSelected = (merchantsSelected: string[]) => {
  const storage = getConfigs()
  localStorage.setItem(
    'BENTO_CONFIGS',
    JSON.stringify({
      ...storage,
      merchantsSelected,
    })
  )
}

const getMerchantsSelected = (): Array<string> => {
  const storage = getConfigs()

  if (storage?.merchantsSelected) {
    return storage.merchantsSelected
  }

  return []
}

const saveTheme = (theme: string) => {
  if (typeof window !== 'undefined') {
    const storage = getConfigs()
    if (storage?.theme !== theme) {
      localStorage.setItem(
        'BENTO_CONFIGS',
        JSON.stringify({ ...storage, theme })
      )
    }
  }
}

const saveMessagingToken = (messagingToken: string) => {
  if (typeof window !== 'undefined') {
    const storage = getConfigs()

    localStorage.setItem(
      'BENTO_CONFIGS',
      JSON.stringify({ ...storage, messagingToken })
    )
  }
}

const getMessagingToken = (): string => {
  const storage = getConfigs()

  if (storage?.messagingToken) {
    return storage.messagingToken
  }

  return ''
}

const saveDeviceId = (deviceId: string) => {
  if (typeof window !== 'undefined') {
    const storage = getConfigs()

    localStorage.setItem(
      'BENTO_CONFIGS',
      JSON.stringify({ ...storage, deviceId })
    )
  }
}

const getDeviceId = (): string => {
  const storage = getConfigs()

  if (storage?.deviceId) {
    return storage.deviceId
  }

  return ''
}

const getConfigs = (): StorageConfigs | null => {
  if (typeof window !== 'undefined') {
    const storage = localStorage?.getItem('BENTO_CONFIGS')

    if (storage) {
      return JSON.parse(storage)
    }
  }
  return null
}

export default {
  saveDate,
  getDate,
  saveSlidePosition,
  getSlidePosition,
  saveMerchantsSelected,
  getMerchantsSelected,
  getConfigs,
  saveTheme,
  saveMessagingToken,
  getMessagingToken,
  saveDeviceId,
  getDeviceId,
}
